<template>
  <div>
    <SubFactorFilter :action="filterAction" />
    <page-title class="mt-2" title_text="لیست تراکنش های فاکتور"></page-title>
    <kt-datatable ref="datatable" v-bind="datatableProps"></kt-datatable>
  </div>
</template>

<script>
import Pagination from '@/components/main/pagination.vue';
import toastr from 'toastr';
import PageTitle from "@/components/main/components/pageTitle.vue";
import { ShopApiUrl } from '@/common/api.service';
import { AuthorizationHeader } from '@/common/jwt.service';
import columns from '@/views/online-factor/datatable/columns_sub_factors';
import actionColumns from '@/views/online-factor/components/FactorTransactionActionColumn.vue';
import SubFactorFilter from './components/sub-factor-filter.vue';

export default {
    name: 'FactorTransactionList',
    components: { SubFactorFilter, Pagination, PageTitle },
    data() {
      return {
        perpage: {
          value: 15,
        },
        query: {},
        factor_hashid: this.$route.params.hashid
      }
    },
    computed: {
      datatableProps() {
        return {
            id: 'datatable',
            data: {
                type: 'remote',
                source: {
                    read: {
                        url: ShopApiUrl.path(`factor/${this.factor_hashid}/sub-factors`),
                        method: 'GET',
                        headers: AuthorizationHeader,
                        map: function(res) {
                            return res.data.data
                        },
                        params: this.query,
                    }
                },
                pageSize: 10,
                serverPaging: true,
                serverFiltering: true,
                serverSorting: true,
            },
            layout: {
            },
            pagination: false,
            sortable: true,
            columns: columns,
            actions: actionColumns
        }
      },
      toastr() {
        toastr.options = {
          closeButton: true,
          positionClass: "toast-bottom-center",
          preventDuplicates: false,
          rtl: false
        }
        return toastr
      },
    },
    methods: {
      filterAction(e, query) {
        this.query = {
          status: query.status,
          from_date: query.from_date,
          to_date: query.to_date,
          customer_fullname: query.customer_fullname,
        };

        if (this.$refs.datatable) {
          this.$refs.datatable.reload();
        }
      },
    },
};
</script>

<style scoped>

</style>
